import { render, staticRenderFns } from "./VehicleDwellTimeTable.vue?vue&type=template&id=5f55d0b8"
import script from "./VehicleDwellTimeTable.vue?vue&type=script&lang=js"
export * from "./VehicleDwellTimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports